import { render, staticRenderFns } from "./details.vue?vue&type=template&id=19f13f84&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./details.vue?vue&type=style&index=1&id=19f13f84&scoped=true&lang=css&"
import style2 from "./details.vue?vue&type=style&index=2&lang=css&"
import style3 from "./details.vue?vue&type=style&index=3&id=19f13f84&scoped=true&lang=css&"
import style4 from "./details.vue?vue&type=style&index=4&id=19f13f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f13f84",
  null
  
)

export default component.exports